'use client';

import { createContext } from 'react';

import { FeatureFlag, localFeatureFlagValues } from '../../constants';

export const FeatureFlagsContext = createContext<{
  allowedEditingFeatureFlags: boolean;
  featureFlags: typeof localFeatureFlagValues;
  featureFlagsToOverride: Partial<typeof localFeatureFlagValues>;
  isInitialized: boolean;
  resetFeatureFlagLocally: (key: FeatureFlag) => void;
  setFeatureFlagLocally: (key: FeatureFlag, value: any) => void;
}>({
  allowedEditingFeatureFlags: false,
  featureFlags: localFeatureFlagValues,
  featureFlagsToOverride: {},
  isInitialized: false,
  resetFeatureFlagLocally: () => {},
  setFeatureFlagLocally: () => {},
});
